import { IApplicationState } from '../../../../types/types';
import { TBoardId } from '../../../../types/types';
import { IOrderType } from '../store/listViewBoard/types';
import { getListViewBoard } from './getListViewBoard';

const DEFAULT_VALUE = {} as IOrderType; // возвращаем тот же объект, чтобы не ререндерить

export const getOrderType = (
    state: IApplicationState,
    boardId: TBoardId
): IOrderType => {
    return getListViewBoard(state, boardId).orderType || DEFAULT_VALUE;
};
